<!-- 由 Dioa 创建于 2022-08-25 星期四 -->
<template>
  <div class="weight-chart" id="weight-chart"> </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'weight-chart',

  components: {},

  props: {
    chartData: {
      type: Array,
      default: () => {
        return []
      }
    },
    timeData: {
      type: Array,
      default: () => {
        return []
      }
    },
    weightTabKey: {
      default: () => {
        return ''
      }
    }
  },

  data() {
    return {
      myChart: null
    }
  },

  computed: {},

  watch: {
    chartData() {
      this.initChart()
    }
  },

  created() {},

  mounted() {
    this.initChart()
  },

  destroyed() {},

  methods: {
    initChart() {
      let that = this
      let start = this.timeData.length - 6 > 0 ? this.timeData.length - 6 : 0
      let end = this.timeData.length - 1 > 0 ? this.timeData.length - 1 : 0
      let option = {
        dataZoom: [
          {
            type: 'inside'
            // startValue: start,
            //endValue: end,
            // zoomLock: true,
            //  preventDefaultMouseMove: false //禁止canvas上下滑动
          }
        ],
        color: ['#6236FF'],
        grid: {
          top: 20,
          bottom: 20,
          left: 0,
          right: 5
        },
        xAxis: {
          type: 'category',
          data: that.timeData,
          splitLine: {
            show: true
          },
          axisLabel: {
            fontSize: 10,
            color: 'rgba(0,0,0,0.5)'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          triggerOn: 'click',
          formatter: function (value) {
            let title = ''
            let unit = ''
            if (that.weightTabKey == 0) {
              title = '体重变化'
              unit = 'KG'
            } else if (that.weightTabKey == 1) {
              title = '腰围变化'
              unit = 'CM'
            } else {
              title = 'BMI变化'
              unit = ''
            }
            let data = value[0]
            let str = `
              <div style="font-size: 14px; color: #000; font-weight: bold">${title}</div>
              <div style="display: flex; align-items: center">
                <span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: ${data.color}; margin-right: 5px"></span> 
                <span style="font-size: 12px; color: rgba(0,0,0,0.5); margin-right: 10px">${data.axisValue}:</span> 
                <span style="font-size: 12px; color: #000; font-weight: bold">${data.value} ${unit}</span> 
              </div>
            `
            return str
          }
        },
        yAxis: {
          type: 'value',
          show: false,
          min: function (value) {
            return value.min - 5
          }
        },
        series: [
          {
            label: {
              show: true,
              formatter(params) {
                let { dataIndex, data } = params
                if (
                  dataIndex != 0 &&
                  dataIndex % 2 != 0 &&
                  dataIndex != that.chartData.length - 1
                ) {
                  return ''
                }
                if (dataIndex != that.chartData.length - 1) {
                  return `{a|${data}}`
                } else {
                  return `{b|${data}}`
                }
              },
              rich: {
                a: {
                  color: '#6236FF',
                  fontWeight: 'bold'
                },
                b: {
                  color: '#F04646',
                  fontWeight: 'bold'
                }
              }
            },
            symbol: 'circle',
            symbolSize: 6,
            data: that.chartData,
            smooth: true,
            type: 'line',
            lineStyle: {
              width: 3
            }
          }
        ]
      }

      if (!this.myChart) {
        this.myChart = echarts.init(document.getElementById('weight-chart'))
      }

      option && this.myChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.weight-chart {
  height: vw(112);
  width: vw(327);
  box-sizing: border-box;
}
</style>
